/* eslint-disable no-constant-condition */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import NewYHConstract from '@/mixins/constracts';
import { Component, Mixins } from 'vue-property-decorator';

const style = require('./index.module.scss');

@Component({ name: 'YHApplyChoose' })
export default class YHApplyChoose extends Mixins(NewYHConstract) {
  private render() {
    return (
      <div class={style.YHApplyChoose}>
        <p class={style.title}>
          <strong>合同编号：{this.constractForm.contractNo || ''}</strong>
        </p>
        <p class={style.title}>
          <strong>个人借款</strong>
        </p>
        <p class={style.title}>
          <strong>授信额度合同</strong>
        </p>
        <p class={style.title}>
          <strong>敬请注意</strong>
        </p>
        <p>为了维护您的合法权益，请在签署本合同之前，仔细阅读以下注意事项：</p>
        <p>1、您已经阅读并接受本合同的所有条款，并知悉其含义；</p>
        <p>2、您确认向{!this.funderCode ? '银行' : '金融机构'}所作的陈述是真实、合法、完整和有效的；</p>
        <p>
          3、您已经确认在授信人、贷款服务顾问或其关联公司的网站或其他与本贷款相关的软件客户端点击
          接受本合同，即意味着已阅读本合同所有条款，并对本合同条款的含义及相应的法律后果已全部通
          晓并充分理解，同意作为受信人接受本合同约束。
        </p>
        <p>
          <strong>
            4、您确认或接受本合同后本合同立即生效，但通过授信人审核通过后才获得有效额度。受信人可使
            用的授信额度类型为循环额度。具体额度以授信人审批结果为准。授信人有权于授信额度建立后每
            半年将根据受信人的情况进行重新审批并更新授信额度。同时授信人保留随时调整额度与利率的权
            利。
          </strong>
        </p>
        <p>
          <strong>
            5、您确认并接受，无论申请是否成功，授信人不受本合同有效期限制并有权决定给予的贷款服务或
            额度并非构成授信人必须履行发放贷款的义务。您使用服务或额度，仍需要经过逐笔申请及授信人
            审批和同意。
          </strong>
        </p>
        <p>
          <strong>
            6、您确认并同意授权授信人有权{!this.funderCode ? '' : '向'}合法留存受信人信息和数据的第三方（包括但不限于向征信机构、行政机关、事业单位、司法机关、监管部门、中国互联网金融协会等行业自律组织或授信人的其他关联公司、合作方）查询、了解核实有关受信人的信息和数据，包括但不限于身份、住所地、还款能力、交易的真实性、土地所有权/使用权/共有权等物权状况、房产状况、财税状况、基金、保险、股票、信托、债券等投资理财信息和诉讼信息、负债信息（若有）和相关证照等，并有权要求受信人提供相关文件资料。
          </strong>
        </p>
        <p>
          <strong>
            7、您确认并同意授信人有权通过其他合法途径了解、核实有关您本人的信息和数据，包括但不限于
            身份、住所地、还款能力、交易的真实性、财务状况和诉讼信息（如有）等等，并权要求您提供相
            关文件资料。
          </strong>
        </p>
        <p>
          <strong>
            8、您确认并同意上述信息提供给授信人之前已清楚知晓可能带来的不利后果，包括但不限于基于前
            述信息对您做出的负面评价。
          </strong>
        </p>
        <p>
          <strong>
          9、如果您对本合同还有疑问之处，您可以通过“臻有钱”贷款平台咨询、了解{this.constractForm.funderName}个人信用消费贷款业务。
          </strong>
        </p>
        <p class={style.title}>
          <strong>个人借款授信额度合同</strong>
        </p>

        <p>立约人：</p>
        <p>受信人：见本合同第二十三条。</p>
        <p>授信人：见本合同第二十三条。</p>

        <p>目录</p>
        <p>第一章 总则</p>
        <p>第二章 授信额度和授信期限</p>
        <p>第三章 提款</p>
        <p>第四章 主要权利和义务</p>
        <p>第五章 违约责任</p>
        <p>第六章 其他约定事项</p>
        <p>第七章 特别签约条款</p>

        <p>第一章 总则</p>
        <p>第一条签订依据</p>
        <p>
          依据《中华人民共和国民法典》、《个人贷款管理暂行办法》等法律、法规、金融监管规定和授信人相关规章制度的规定，合同双方经协商一致，特立本合同。
        </p>
        <p>第二条 定义</p>
        <p>
          个人信用消费贷款授信业务，是指受信人向授信人提出授信申请，授信人经审核同意给予受信人在
          约定期限内的授信额度，受信人可在此额度内提款用于其本人消费用途的业务模式。
        </p>

        <p>第二章 授信额度和授信期限</p>
        <p>
           第三条 授信额度循环额度是指授信人在授信有效期间根据本合同为受信人提供的循环使用的所有贷款本金余额的最高限额。
        </p>
        <p>循环额度＝合同项下未清偿的贷款余额+可使用额度</p>
        <p>
          受信人可使用的授信额度见本合同第二十四条。授信额度由授信人一次性核定。
        </p>
        <p>
          <strong>第四条 授信用途</strong>
        </p>
        <p>
          受信人使用该授信额度，用于合法、合规的消费用途，具体用途见本合同第二十五条。
        </p>
        <p>
          <strong>第五条 授信期限</strong>
        </p>
        <p>
          授信期限是指授信人给予受信人相应授信额度贷款的有效期间。若授信人审核通过的，受信人应在
          授信期限和授信额度内，向授信人申请贷款。对于受信人在授信期限和授信额度提出的每次申请，授信人有权根据审批规则自主决定是否给予发放贷款，授信期限见本合同第二十六条。
        </p>
        <p>第六条 贷款到期日</p>
        <p>
          贷款到期日是指授信人给予受信人相应授信额度内发放的具体每笔贷款的贷款到期日。
        </p>
        <p>
          <strong>第三章 提款</strong>
        </p>
        <p>
          <p>
            <strong>第七条 受信人提款先决条件</strong>
          </p>
          <p>1、未出现或未可能出现本合同约定的违约情形；</p>
          <p>2、提款金额不超过本合同中约定的可使用额度；</p>
          <p>3、在授信额度有效期限内提款；</p>
          <p>4、通过授信人电子渠道提款的单笔申请金额不低于人民币壹元；</p>
          <p>5、提款用途符合本合同约定；</p>
          <p>6、贷款资金支付方式符合监管部门及授信人的相关规定；</p>
          <p>7、受信人信用状况未恶化或未出现可能恶化的情形；</p>
          <p>8、达到授信人要求的其他条件。</p>
          <p>
            <p>
              <strong>第八条 提款程序</strong>
            </p>
            <p>
              受信人每次提款前，须提前通过授信人有权经办机构与授信人签署《个人消费贷款合同》受信人通
              过电子渠道的提款申请，经授信人审核同意后，根据上述《个人消费贷款合同》约定的支付方式将
              {
                !this.funderCode ? '贷款资金划至约定的账户' : '贷款资金划至约定的借款人本人银行账户或支付账户'
              }。
            </p>
            <p>
              <strong>第四章 主要权利和义务</strong>
            </p>
            <p>
              <p>
                <strong>第九条 受信人承诺</strong>
              </p>
              <p>
                1、是具有完全民事行为能力的自然人，具有签订和履行本合同的能力和资格。
              </p>
              <p>2、已充分了解本合同及其它相关文件的全部内容。</p>
              <p>
                3、向授信人提交的所有证明、文件等资料都是真实、合法、完整、有效的。
              </p>
              <p>4、签订和履行本合同，与其签订和履行其他任何合同均无抵触。</p>
              <p>
                5、未有严重疾病、重大债务、涉及调解、仲裁、诉讼、索赔、强制执行和可能危及授信人权益的其
                他事件。
              </p>
              <p>
                {
                  !this.funderCode ? `6、受信人同意将其个人信用信息提供给中国人民银行个人信用信息基础数据库或经监管部门批准建
                  立的个人信用数据库，并授权授信人因贷款审查及贷后管理的需要查询并留存受信人及其配偶的个
                  人信用信息。` : '6、非为在校大学生'
                }
              </p>
              <p>
                7、受信人同意将其个人信用信息提供给
                {
                  !this.funderCode ? `贷款服务平台等第三方外部信息服务机构或如芝麻信用管理
                  有限公司等其他依法设立的征信机构，并授权授信人因贷款审查及贷后管理的需要查询并留存受信
                  人及其配偶的个人信用信息。` : '中国人民银行个人信用信息基础数据库或经监管部门批准建立的个人信用数据库，并授权授信人因贷款审查及贷后管理的需要查询并留存受信人的个人信用信息。'
                }
              </p>
            </p>
            <p>
              <p>
                <strong>第十条 受信人的主要权利</strong>
              </p>
              <p>1、有权依本合同的约定获得贷款。</p>
              <p>
                2、有权向授信人了解、咨询、知悉个人信用消费贷款业务有关事项。
              </p>
            </p>
            <p>
              <p>
                <strong>第十一条 受信人的主要义务</strong>
              </p>
              <p>
                1、按本合同的约定履行还款义务。受信人不得以未收到授信人寄送的对账单、联系单、还款计划、
                还款短信或与第三方发生纠纷等任何理由不履行本合同约定的还款义务。
              </p>
              <p>
                2、贷款用途符合国家法律法规及有关政策规定，并按合同约定的用途使用贷款，不得挪用贷款。
              </p>
              <p>3、受信人应在下列情况发生之日起十日内以书面形式通知授信人：</p>
              <p>
                3.1出售、转让、赠送、处分、购买自有房屋、车辆、古董或其他贵重物品，或转让、赠与、处分本
                人及其家庭成员的大额有价证券、存款的；
              </p>
              <p>
                3.2发生针对受信人或受信人家庭的诉讼、仲裁、索赔、强制执行或行政措施、刑事处罚等；
              </p>
              <p>
                3.3受信人或家庭成员的婚姻状况、家庭收入发生重大变化或家庭发生其他重大变故；
              </p>
              <p>
                3.4受信人信用状况出现恶化或可能出现恶化的，包括但不限于贷款、银行卡或在其他业务中出现逾
                期还款，涉及债务纠纷、民间借贷、被其他第三方请求履行担保责任、受到行政或刑事处罚等；
              </p>
              <p>3.5其他可能危及受信人还款能力的事件。</p>

              <p>
                4、如实向授信人提供申请授信所需的各种资料，包括婚姻状况证明、收入证明、个人所得税税单、
                存款证明、扶（抚）养人情况证明等，并保证所提供的所有资料均为真实、有效、完整。
              </p>
              <p>5、配合授信人对其信用状况进行调查。</p>
              <p>
                6、不得隐瞒本人或其家庭成员存在严重疾病、负有重大债务等可能危及授信人债权的其他情形。
              </p>
              <p>
                7、未经授信人书面同意，不得对外提供担保，或以其或家庭成员的自有财产为他人提供抵押、质押
                担保。
              </p>
              <p>
                8、住所地、现住地址、联系方式、工作单位、单位地址、职务、单位业务性质等个人基本情况发生
                变化时，应于变更事件发生的十日内书面通知授信人。
              </p>

              <p>
                9、配合授信人检查、监督借款使用情况、收入状况、对外担保等情况，并配合提供有关资料。
              </p>

              <p>
                10、除有关部门另有规定外，受信人应根据法律法规规定及本合同约定承担本合同项下的相关费用
                和税费。
              </p>
            </p>

            <p>
              <p>
                <strong>第十二条 授信人的主要权利</strong>
              </p>
              <p>1、有权对受信人提供的资料、文件的合法性、真实性进行调查。</p>
              <p>2、有权检查贷款的使用情况。</p>
            </p>

            <p>
              <p>
                <strong>第十三条 授信人的主要义务</strong>
              </p>
              <p>1、按本合同的约定发放贷款。</p>
              <p>2、对未获批准的提款申请，授信人应及时告知受信人。</p>
            </p>

            <p>
              <p>
                <strong>第五章违约责任</strong>
              </p>
            </p>
            <p>
              <p>
                <strong>第十四条 违约情形</strong>
              </p>
              <p>受信人发生下列情形之一的，即构成违约：</p>
              <p>1、受信人虚构贷款用途；</p>
              <p>2、受信人违反本合同约定挪用贷款资金；</p>
              <p>
                3、贷款期间（包括贷款提前到期），受信人未按照本合同约定按时归还贷款本息或其他应付款项的
                （包括贷款逾期后受信人已归还逾期本息或由担保人（若有）代其履行的情形）；
              </p>
              <p>
                4、受信人向授信人提交的有关证明和文件或其所作出的任何声明、保证和承诺为不真实、不准确、
                不完整或存在虚假记载、误导性陈述或者重大遗漏等；
              </p>
              <p>
                5、受信人申请借款时隐瞒本人或其家庭成员存在严重疾病，或负有重大债务，或涉及调解、仲裁、
                诉讼、索赔、强制执行及其他严重影响其还款能力的情形（一项或多项）；
              </p>
              <p>
                6、受信人死亡或被宣告死亡而其财产合法继承人不继续履行本合同的，或受信人被宣告失踪而其财
                产代管人不继续履行本合同的，受信人丧失民事行为能力而其监护人不继续履行本合同的；
              </p>
              <p>
                7、受信人或受信人家庭成员发生因不能履行本合同义务之资信状况恶化、疾病、事故、死亡或还贷
                能力出现其他重大变化（包括但不限于国籍变更或迁往境外、住所地变更、婚姻情况变动、家庭财
                务状况恶化、收入降低、失业、重大疾病、拖欠其他债务等）等；
              </p>
              <p>
                8、受信人卷入或即将卷入民事诉讼、仲裁、索赔或其他法律纠纷，或被强制执行，或受到行政或刑
                事处罚，或被国家行政或司法机关宣布对其财产没收或对其处分权的限制，或存在该种情况发生可
                能的威胁；
              </p>
              <p>
                9、受信人低价转让、无偿转让或隐藏财产、减免第三方债务、怠于行使债权或其他权利，授信人认
                为可能危及本合同项下债权安全的；
              </p>

              <p>
                10、受信人未履行对{this.constractForm.funderName || ''}负有的其他到期债务，或授信人发
                现受信人有其他拖欠债务的行为的；
              </p>

              <p>
                11、受信人发生其他足以对其偿还债务能力造成不利影响的事件，或受信人明确表示或以其行为表
                明将不履行本合同项下的义务；
              </p>
              <p>
                12、受信人拒绝授信人对其使用借款情况和收入状况、对外担保等情况进行检查监督，拒绝提供有
                关资料，或提供虚假材料的；
              </p>

              <p>13、受信人违背本合同所作的任何一项承诺的；</p>
              <p>14、受信人违反本合同其他约定的。</p>
            </p>

            <p>
              <p>
                <strong>第十五条 授信人可采取的措施 </strong>
              </p>
              <p>
                <strong>
                  受信人违约的，授信人或其代理方有权采取下列一种或数种措施：
                </strong>
              </p>
              <p>
                <strong>1.冻结受信人尚未使用的授信额度；</strong>
              </p>
              <p>
                <strong>
                  2.减少、取消或终止受信人尚未使用的授信额度和授信期限；
                </strong>
              </p>
              <p>
                <strong>3.要求受信人按授信人的要求变更贷款支付方式；</strong>
              </p>
              <p>
                <strong>4.宣布所有贷款到期，提前收回已发放的贷款本息。</strong>
              </p>
              <p>
                <strong>
                  5.按违约天数、金额计收贷款逾期、贷款挪用的罚息；
                </strong>
              </p>

              <p>
                <strong>
                  6、要求受信人对本合同项下所有债务提供符合授信人要求的新的担保；
                </strong>
              </p>
              <p>
                <strong>7、提前解除本合同；</strong>
              </p>
              <p>
                <strong>8、要求受信人限期纠正违约行为并赔偿相应损失；</strong>
              </p>

              <p>
                <strong>
                  9、委托第三方或通过任何公众媒体发布公告等方式进行催收或追偿；
                </strong>
              </p>

              <p>
                <strong>
                  10、向人民法院起诉，采取查封、冻结、扣划等资产保全措施；
                </strong>
              </p>

              <p>
                <strong>
                  11、向受信人收取授信人为实现债权的所有相关费用；
                </strong>
              </p>

              <p>
                <strong>12、授信人认为应当采取的其他措施。</strong>
              </p>

              <p>
                <strong>
                  授信人采取上述措施无需征得受信人的同意，相关决定一经作出，随即生效；授信人只限于通过《
                  个人消费贷款合同》约定的通讯地址通知受信人，但授信人无义务必须通知受信人；无论何种原因
                  造成通知不及时、通知未达或无法通知等情形的，不影响授信人决定的有效性，授信人也不因此承
                  担任何法律责任。
                </strong>
              </p>
              <p>
                <strong>
                  因授信额度减少，导致本合同项下贷款余额大于最高贷款限额时，受信人的实际债务以本合同项下
                  的未清偿债务为准。
                </strong>
              </p>
            </p>

            <p>
              <p>
                <strong>第十六条 合同解除或终止</strong>
              </p>
              <p>
                出现下列任一情形时，授信人有权解除或终止合同并要求受信人归还贷款本息和其他应付款项。
              </p>
              <p>1、受信人未按合同约定履行还款义务；</p>
              <p>2、受信人未按本合同约定归还积欠贷款本息的；</p>
              <p>
                3、受信人申请授信时提供虚假的收入、婚姻状况、家庭状况、个人资产等证明材料、扶（抚）养人
                情况说明等；
              </p>
              <p>
                4、受信人申请授信时隐瞒本人存在严重疾病、负有重大债务、涉及调解、仲裁、诉讼、索赔、强制
                执行及其他严重影响其还款能力的情形；
              </p>
              <p>5、受信人死亡或被宣告死亡或被宣告失踪而无人代其履行债务的；</p>
              <p>
                6、受信人发生不能履行本合同义务的个人信用状况恶化、疾病、事故等事件；
              </p>
              <p>
                7、受信人卷入民事纠纷，影响或可能影响其在本合同项下债务履行；或受信人触犯刑律，可能被处拘役以上刑罚，或由国家行政或司法机关宣布对其财产予以没收或限制其处分的，或存在上述情况发生可能的危险的；
              </p>
              <p>8、受信人违反本合同其他约定，影响授信人债权实现的。</p>
              <p>
                9、在本合同有效期间，因法律、法规或监管规定的变化而致使本合同无效或违反监管相关规定；
              </p>
            </p>

            <p>
              <p>
                <strong>第六章 其他约定事项</strong>
              </p>
              <p>
                <strong>第十七条争议解决</strong>
              </p>
              <p>
                合同各方在履行合同过程中发生争议的，可以协商解决，也可以直接向授信人所在地或借款人所在地的人民法院提
                起诉讼。在协商或诉讼期间，本合同不涉及争议部分的条款仍须履行。
              </p>
              <p>
                第十八条合同构成
                本合同由本合同条款、受信人在贷款平台信息系统填写的所有信息以及贷款平台各项规则以及与本贷款相关的网络页面信息、《个人消费贷款合同》组成，各组成部分均具有法律效力。
              </p>
              <p>
                <strong>第十九条合同变更、补充</strong>
              </p>
              <p>
                1、授信人有权对合同内任何条款进行变更或补充其他未尽事宜，受信人对此表示认可，如受信人在
                合同变更或补充后仍继续接受授信人通过合作方提供的贷款服务的，则视为受信人接受对本合同的
                变更或补充，应遵循相关条款的约束。。
              </p>
              <p>2、变更或补充内容与本合同具有同等法律效力。</p>
              <p>
                <strong>第二十条合同形式及生效</strong>
              </p>
              <p>授信人与受信人一致本同意以数据电文形式订立并认同其效力。</p>
              <p>
                受信人在贷款平台确认本合同后本合同立即生效，经过授信人审核通过后额度生效。
              </p>

              <p>
                <strong>第二十一条未尽事宜</strong>
              </p>
              <p>本合同未尽事宜按国家有关法律、法规、金融监管规定执行。</p>

              <p>
                <strong>第二十二条 其他事项</strong>
              </p>
              <p>
                <strong>
                  授信人在本合同项下的权利并不影响和排除其根据法律、法规和其它合同所享有的任何权利。授信 人任何对违约或延误行为施以任何宽容、宽限、优惠或延缓行使本合同项下的任何权利，均不能视 为对本合同项下权利、权益的放弃或对任何违反本合同行为的许可或认可，也不限制、阻止和妨碍 授信人对该权利的继续行使或对其任何其它权利的行使，也不因此导致授信人对合同其他各方承担 义务和责任。
                </strong>
              </p>
            </p>

            <p>
              <p>
                <strong>第七章 特别签约条款</strong>
              </p>
              <p>
                <strong>第二十三条 对立约人的说明</strong>
              </p>
              <p>
                <strong>本合同的立约人为：</strong>
              </p>
              <p>
                <strong>受信人：</strong>
              </p>
              <p>
                <span>姓名：{this.constractForm.userName || ''}</span>
              </p>
              <p>
                <span>证件号码：{this.constractForm.idCard || ''}</span>
              </p>
              <p>
                <span>证件类型：身份证</span>
              </p>
              <p>
                <span>授信人：{this.constractForm.funderName || ''}</span>
              </p>

              <p>
                <strong>第二十四条授信额度</strong>
              </p>

              <p>
                受信人可使用的授信额度类型为循环额度。具体额度以授信人审批结果为准。授信人有权每半年将
                根据受信人的情况进行重新审批并更新授信额度。
              </p>

              <p>
                <strong>第二十五条授信用途</strong>
              </p>

              <p>受信人的授信额度具体用于：本人的日常消费。</p>
              <p>
                本合同授信额度内每笔借款的具体用途详见受信人向授信人提交的《个人消费贷款合同》
                受信人承诺严格按本合同约定的用途使用贷款，不挤占挪用贷款，不将贷款用于从事股本权益性投
                资、股票、基金、期货、金融衍生品投资以及其他法律、法规、规章及监管规定禁止的用途；不以
                通过本合同借款所取得的财产从事违反国家法律、法规的活动。
              </p>

              <p>
                <strong>第二十六条 授信期限</strong>
              </p>
              <p>
                本合同项下的授信期限为一年。具体授信期限起始日和到期日以授信人系统签发为准。
              </p>

              <p>
                <strong>第二十七条 其它约定</strong>
              </p>

              <p>
                <strong>
                  受信人贷款利率、提款及贷款资金支付和扣款与还款、罚息等有关约定详见后续签署的《个人消费
                  贷款合同》。
                </strong>
              </p>

              <p>
                <strong>第二十八条 特别提示</strong>
              </p>
              <p>
                <strong>
                  1、在签署本合同时，授信人就本合同的全部条款已向合同各方进行了详细地说明和解释，合同各方
                  对合同的全部条款均无疑义，并对当事人有关权利义务和责任限制或免除条款的法律含义有准确无
                  误的理解。
                </strong>
              </p>

              <p>
                <strong>
                  2、本合同项下银行向客户所收取的利息（含罚息、复利等）、违约金及其他费用等均为含税费用
                  ，包括但不限于增值税等相关税费。
                </strong>
              </p>

              <p>
                <strong>
                  3、受信人对于本合同加粗加黑的合同生效及授信人每半年将根据受信人情况进行重新审批并更新授
                  信额度内容已充分理解掌握并放弃争议抗辩权。
                </strong>
              </p>
            </p>
          </p>
        </p>
        <br/>
        <br/>
        <br/>
        <p>
        （以下无正文）
        </p>
        <p>
          <strong>借款人：{this.constractForm.userName || ''}</strong>
        </p>
        <p>
          <strong>日期：{this.constractForm.effectiveDate || ''}</strong>
        </p>
        <p>
          <strong>电子签名：</strong>
        </p>
        <br/>
        <br/>
        <p>
          <strong>贷款人：{this.constractForm.funderName || ''}</strong>
        </p>
        <p>
          <strong>日期：{this.constractForm.effectiveDate || ''}</strong>
        </p>
        <p>
          <strong>电子签名：</strong>
        </p>
        <br/>
        <br/>
        <p class={style.title}>
          <strong>个人信息查询及使用授权书</strong>
        </p>
        <p>重要提示：</p>
        <p>为了保障您的合法权益，您应当阅读并遵守《个人信息查询及使用授权书》（以下称“本授权书”）。 <strong>请您务必审慎阅读、充分理解本授权书全部条款内容，特别是免除或者减轻杭银消费金融股份有限公司(以下简称“被授权人”或“贵司”)责任，或限制您权利的条款，其中免除或者减轻责任条款将以加粗形式提示您注意。</strong></p>
        <p><strong>您的点击确认等行为即视为您已阅读并同意受本授权书条款约束，即视为您已确认签署本合同。为数据电文存证需要并保证签署数据电文合同文本的真实、完整、不可篡改，您不可撤销地授权贷款人合作的电子签名服务机构根据您提供的个人信息向取得认证资格的电子认证机构申请电子签章，您已知晓您的电子签章将由电子认证机构保管，并同意在借款申请过程中根据您发出的指令（即您点击确认合同文本动作本身）自动调取及在您确认签署的合同文本中使用您的电子签章。</strong></p>
        <br/>
        <br/>
        <p>杭银消费金融股份有限公司:</p>
        <p>本人充分理解并同意，本消费贷款服务是被授权人通过其自有或合作平台(指与贵司存在合作关系的第三方网络平台)为本人提供的消费贷款服务，现本人主动申请此项服务。<strong>为使贵司客观、准确、全面、及时地评估本人的信用等级、履约能力及意愿，对本人在贵司的全部借款活动进行全周期管理(贷款决策、贷中管理、贷后催收等)，以及为本人提供优质的金融服务，同时履行法律法规或监管要求金融机构必须履行的一些法定义务(如反洗钱等)，</strong>就采集、查询、使用本人的相关必要信息，本人无条件地同意并授权如下:</p>
        <p><strong>一、被授权人通过合理途径采集并存储本人信息，包括:</strong></p>
        <p><strong>1.本人在消费贷款服务使用过程中主动提供的信息，</strong>包括在贵司自有或合作平台页面主动填写的个人信息，咨询投诉、解决争议或与贵司主动联系时所提供的信息。这类信息包括本人姓名、性别、出生日期、证件类型、证件号码、证件有效期、手机号码、联系地址、单位地址、银行卡信息、学历、职业及单位信息、家庭状况、收入状况、财产信息、第三方支付账户信息、公积金信息、联系人信息，最终收集信息内容以实际为准。</p>
        <p><strong>2.本人在消费贷款服务使用过程中产生的以及有关使用方式的信息，</strong>包括本人的人脸信息、位置信息、设备信息、软件使用记录、操作行为信息及相关日志信息。</p>
        <p><strong>3.贵司向中国人民银行金融信用信息基础数据库，依法设立的其他征信机构（百行征信、朴道征信）及其合作的第三方数据源公司、数据服务机构、信息查询服务机构及信息验证服务机构，司法机关，政府部门（</strong>税务机关、社保机构、民政部门、公积金管理部门）<strong>及其他依法设立的第三方机构</strong>(包括行业协会、物流、电子商务平台、通信运营商、互联网平台等第三方机构)<strong>，贵司关联公司，</strong>为向本人提供消费贷款服务而与贵司开展合作的合作伙伴及其关联公司<strong>查询、采集、验证与本人申请、使用消费贷款服务相关的个人信息</strong>(包括本人身份信息、信用和信贷信息、信用评分、财产信息、社会保险及公积金相关信息、联系人信息、就业信息、学历信息、婚姻情况、地址信息、位置数据、互联网使用信息、互联网使用行为)。</p>
        <p><strong>4.其他申请、使用被授权人的消费贷款服务所必需提供的个人信息。</strong></p>
        <p><strong>二、被授权人基于合理目的使用本人信息，包括:</strong></p>
        <p><strong>1.为认证本人身份的真实性，将本人有效身份证件信息、银行卡信息及手机号、个人生物识别信息提交给合法持有上述信息的第三方机构或身份验证机构进行验证。</strong></p>
        <p>2.为管控风险，检测、预防及/或纠正欺诈及其他潜在的非法活动，<strong>使用本人基本信息、身份信息、信用信息、财产信息、设备信息及其他基于本人同意而采集的信息进行安全管理与资格、信用及偿付能力审核。</strong></p>
        <p>3.为向本人提供消费贷款服务，<strong>使用本人基本信息、身份信息、财产信息及其他基于本人同意而采集的信息进行适用性评估（如履行反洗钱义务）、绑定银行卡、支付、验证交易真实性、处理产品或服务请求、完成交易指令、发送交易通知等。</strong></p>
        <p>4.为处理本人逾期、欺诈等恶意行为或其他违法违规、违约行为，<strong>自行或委托第三方服务机构通过信函、短信、电话、上门、公告或司法途径等合法方式催收欠款，并追究法律责任。被授权人有权将必要的本人身份信息及欠款信息提供给该第三方以及本人的担保人、常用或紧急联系人。</strong></p>
        <p>5.为增强贵司消费贷款服务提供能力和服务水平，或展示贵司消费贷款服务的整体使用趋势，<strong>本人了解并同意贵司在不透露本人个人信息的前提下，有权对本人信息进行分析并予以商业化的利用，或与公众、第三方共享不包含个人信息的统计数据；贵司及贵司合作的第三方均可以将采集的与本人相关的信息、数据用于联合开展大数据整理、研究、分析、加工、实验、运用。</strong></p>
        <p><strong>6.为遵守相关法律法规或者行政机关、监管机构等有权部门依法提出的要求而向该等机构提供信息。</strong></p>
        <p>7.为落实监管机构要求或承担金融机构的社会责任，<strong>通过本人提供的联系信息向本人发送风险提示(包括但不限于防范非法集资、防范电信诈骗等)、金融知识等。</strong></p>
        <p>8.为维护贵司及关联公司或合作伙伴、本人或社会公众利益、财产或安全免遭损害而提供必要信息。</p>
        <p>9.为提升本人的服务体验及推荐更为优质或适合的服务，根据本人信息形成特征标签，并向本人提供可能感兴趣的营销活动通知、商业性电子信息或广告等(在本人退订相关广告后，则无法继续发送)。同时，结合收集的本人信息为本人提供更加个性化的服务。</p>
        <p>10.为邀请本人参加与贵司服务有关的客户调研、处理与本人相关的纠纷而使用本人的联系信息。</p>
        <p>11.预防或阻止非法活动。</p>
        <p>12.获得本人同意或授权的其他情形。</p>
        <br/>
        <br/>
        <p>特别说明:</p>
        <p><strong>为满足被授权人贷款决策需要，本人授权与被授权人有合作关系的征信机构可向本人或其他机构采集信息，并可依法整理、保存、加工、使用及向被授权人提供反映本人个人信用状况/风险状况的个人信用/资信报告、评分或其他形式的验证结果。本人同意，经符合行业规范要求的前提下，被授权人可向有合作关系的数据服务机构、信息查询服务机构及信息验证服务机构查询本人风险评分或其他形式的验证结果。</strong></p>
        <br/>
        <br/>
        <p><strong>授权人声明:</strong></p>
        <p>被授权人已明确告知本人签署本授权书可能会使本人个人信息在使用过程中，即使被授权人采取合理的信息安全保护和保密措施但仍不可避免地存在泄漏的可能。<strong>在此情形下，本人同意以网络点击提交或其他线上方式签署本授权书，并接受其所含全部约定内容，确认承担由此产生的一切责任。</strong></p>
        <p><strong>本授权书是本人向被授权人做出的单方承诺，具有独立效力，不因《个人借款授信额度合同》等文本或条款无效或被撤销而无效或失效。本授权书未尽事宜，应参照被授权人隐私政策进行适用。本授权一经做出，便不可撤销。</strong></p>
        <p>以上授权期限为本人作出本授权承诺之日起至本人该笔授信在贵司到期且该笔授信下的欠款等债务全部清偿完毕之日止（处理本人征信异议除外），<strong>但在本人未退订或拒绝的前提下，被授权人始终保留以短信、电子邮箱、移动电话、QQ、微信等联系方式向本人发送产品信息的权利。</strong></p>
        <p>因本合同引起或与本合同有关的任何争议，应协商解决；<strong>协商不成的，双方一致同意提请贷款人所在地或借款人所在地有管辖权的人民法院诉讼解决</strong>。管辖法院有权通过相关电子诉讼程序进行网上视频庭审、异步审理模式庭审，所作出的裁决对双方均具有约束力。败诉方应承担对方为解决本争议而产生的所有费用，包括但不限于诉讼费、律师费、鉴定费、公证费、交通费等。</p>
        <br/>
        <br/>
        <p>特此授权!</p>
        <br/>
        <br/>
        <p>授权人：{this.constractForm.userName || ''}</p>
        <p>授权人证件号码：{this.constractForm.effectiveDate || ''}</p>
        <p>授权日期：{this.constractForm.idCard || ''}</p>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <p class={style.title}>
          <strong>中国互联网金融协会信息使用授权书</strong>
        </p>
        <br/>
        <p><strong>重要提示:</strong></p>
        <p><strong>为了保障您的合法权益，您应当阅读并遵守本授权书，请您务必审慎阅读、充分理解本授权书条款内容，特别是免除或者减轻杭银消费金融股份有限公司（以下简称为“被授权人”）责任或限制您权利的条款，其中免除或者减轻责任条款可能以加粗形式提示您注意。</strong></p>
        <p><strong>除非您已阅读并接受本授权书所有条款，否则您无权使用被授权人提供的贷款服务。您的点击确认等行为即视为您已阅读并同意受本授权书条款约束。</strong></p>
        <p><strong>杭银消费金融股份有限公司：</strong></p>
        <p><strong>本人完全理解并免费授权贵司及贵司信息共享合作伙伴下列权利：</strong></p>
        <p>1、本协议所称的信息共享合作伙伴<strong>指与贵司共同加入中国互联网金融协会互联网金融信息共享平台的其他单位。</strong></p>
        <p>2、本人同意和<strong>授权贵司收集并向中国互联网金融协会报送本人/本单位信用信息，并同意中国互联网金融协会获取、保存、分析处理该信用信息，报送的信用信息包括但不限于主体信息、借款信息、还款信息、逾期信息,以及以虚假主体或仿冒他人名义申请借款、提供虚假申请资料等欺诈信息</strong>（以下简称“信用信息”）。</p>
        <p>3、本人同意并<strong>授权贵司及贵司信息共享合作伙伴可在本人/本单位借款业务申请阶段及业务存续期间向中国互联网金融协会互联网金融信息共享平台查询本人/本单位的信用信息。</strong></p>
        <p>4、本人授权贵司办理以下业务时，<strong>可以通过姓名或名称、证件类型、证件号码向中国互联网金融协会互联网金融信息共享平台查询本人/本单位信用信息：</strong></p>
        <p><strong>（1）审核本人借款申请业务；</strong></p>
        <p><strong>（2）审核本人作为担保人的业务；</strong></p>
        <p><strong>（3）对本人借款申请业务或者作为担保人的业务进行贷后风险管理；</strong></p>
        <p><strong>（4）经中国互联网金融协会同意的其他情况。</strong></p>
        <br/>
        <p><strong>授权人声明：</strong></p>
        <p><strong>本人同意以网络点击提交或其他线上方式签署本授权书，并接受其所含全部约定内容，确认承担由此产生的一切责任。</strong></p>
        <p>本授权书是本人向杭银消费金融股份有限公司做出的单方承诺，具有独立效力，不因《个人借款授信额度合同》等文本或条款无效或被撤销而无效或失效。本授权一经做出，便不可撤销。</p>
        <p>以上授权期限为本人作出本授权承诺之日起至本人该笔授信在贵司到期且该笔授信下的欠款等债务全部清偿完毕之日止。</p>
        <p>若本人与被授权人发生任何纠纷或争议，应以友好协商解决；协商不成的，本人同意将纠纷或争议提请贷款人所在地或借款人所在地有管辖权的人民法院进行审理。管辖法院有权通过相关电子诉讼程序进行网上视频庭审、异步审理模式庭审，所作出的裁决对双方均具有约束力。败诉方应承担对方为解决争议而产生的所有费用，包括但不限于诉讼费、律师费、公证费、交通费等。</p>
        <p><strong>本人已知悉本授权书所有内容（特别是加粗字体内容）的含义以及由此产生的法律效力，基于本人真实的意思表示，自愿作出上述授权并同意承担由此带来的一切法律后果。</strong></p>
        <p>特此授权！</p>
        <br/>
        <p>-</p>
        <p>授权人：{this.constractForm.userName || ''}</p>
        <p>授权人证件号码：{this.constractForm.effectiveDate || ''}</p>
        <p>授权日期：{this.constractForm.idCard || ''}</p>
      </div>
    );
  }
}
